import $ from "jquery";
import React from 'react';
import { Button, Input } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';


import Loading from '../../loadings';
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';

export default class AddSpares extends React.Component {

    state = {
        addingspares: [], spares: [], serialno: this.getFormatedDate(new Date()),
    }

    getFormatedDate(dates, interval) {
        if (interval > 0) {
          dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
        }
        let month = dates.getMonth() + 1; let date = dates.getDate();
        month = (month > 10) ? month : "0" + month;
        date = (date > 10) ? date : "0" + date;
        let x = dates.getFullYear() + "-" + month + "-" + date;
        if (interval == 7) {
          x = dates.getFullYear() + "-" + month + "-01";
        }
        return x;
      }

    getAllSpares = () => {
        let context = this;
        context.setState({ load: true, message: 'Getting Partno!!!' });
        let data = (ReadCookie("branch"));
        let branch_id;
        for (var i = 0; i < data.length; i++) {
            branch_id = data[i].branch_id;
        }
        $.ajax({
            type: 'POST',
            data: { 'branch': branch_id, 'customer': this.props.item.cid, discountlevelid: 0 },
            url: Server() + 'purchasedetail/getpartcode.php',
            success: function(data) {
                try {
                    data = JSON.parse(data);
                    context.setState({ spares: data, load: false, addSpares: true })
                } catch (error) {
                    context.setState({ load: false })
                }
            },
            error: function(err) {
                context.setState({ load: false });
                alert('Try again!!!!')
            }
        });
    }

    addItem = () => {
        let addingspares = this.state.addingspares;
        let i = 1;
        addingspares.map((c) => {
            i = c.id;
        })
        i = i + 1;
        addingspares.push({ id: i, dropdown: '', serialno: this.state.serialno })
        this.setState({ addingspares })
    }

    deleteItem = (id) => {
        let addingspares = this.state.addingspares;
        let newAddItem = [];
        addingspares.map((c) => {
            if (c.id != id) { 
                newAddItem.push(c); 
            }
        })
        let i = 0;
        newAddItem.map((v) => { v.id = i++; })
        this.setState({ addingspares: newAddItem })
    }

    convertIntoNumber(value) {
        try {
            value = Number(value);
        } catch (error) {
            value = 0;
        }
        return value;
    }

    makeDecimalPoint(value) {
        try {
            value = value.toFixed(2);
        } catch (error) {
            value = 0;
        }
        return value;
    }


    partcode = (event, id) => {
        let { spares, addingspares } = this.state;
        let value = event.target.value;
        let part_alias = value.split("->")[0];
        let spare_name = value.split("->")[1];
        let partno = value.split("->")[2];
        let brand_name = value.split("->")[3];
        let i = 1;
        addingspares.map((v) => {
            if (v.id == id) {
                v.dropdown = value;
            }
        })

        spares.map((c) => {
            if (i == 1 && c.part_alias == part_alias && c.spare_name == spare_name && c.partno == partno && c.brand_name == brand_name) {
                addingspares.map((v) => {
                    if (v.id == id) {
                        v.dropdown = value;
                        v.spare_name = spare_name;
                        v.partno = partno;
                        v.mrp = this.convertIntoNumber(c.mrp);
                        v.omrp = this.convertIntoNumber(c.mrp);
                        v.brand_id = c.brand_id;
                        v.brand_id = c.brand_id;
                        v.brand_name = brand_name;
                        v.discountper = 0;
                        v.discountrs = 0;
                        v.tax = c.tax;
                        v.taxprice = 0;
                        v.totprice = 0;
                        i = 0;
                    }
                })
            }
        })
        this.setState({ addingspares })
    }

    onChangess = (type, id) => (f, { value }) => {
        value = Number(value);
        let { addingspares } = this.state;
        addingspares.map((c) => {
            if (c.id == id) {
                if (type == 'qty') {
                    let mrp = this.convertIntoNumber(c.mrp);
                    let omrp = this.convertIntoNumber(c.omrp);
                    let tax = this.convertIntoNumber(c.tax);
                    c.taxprice = ((mrp * value) * tax)/100;
                    c.totprice = (((mrp * value) * tax)/100) + (mrp * value);
                    c.qty = value;
                    c.discountrs = ((((omrp * value) * tax)/100) + (omrp * value)) - ((((mrp * value) * tax)/100) + (mrp * value));
                }
                if (type == 'discountper') {
                    let mrp = this.convertIntoNumber(c.omrp);
                    c.mrp = mrp - ((mrp * value)/100);
                    c.taxprice = ((c.mrp * c.qty) * c.tax)/100;
                    c.totprice = (((c.mrp * c.qty) * c.tax)/100) + (c.mrp * c.qty);
                    c.discountper = value;
                    c.discountrs = ((((c.omrp * c.qty) * c.tax)/100) + (c.omrp * c.qty)) - ((((c.mrp * c.qty) * c.tax)/100) + (c.mrp * c.qty));
                }
            }
        })
        this.setState({ addingspares })
    }

    AddSpares = () => {
        let context = this;
        let spares = this.state.addingspares;
        let check = '0';
        spares.map((c) => {
            if (!c.qty) {
                check = 1;
            }
        })
        if (check != '0') {
            alert('Entry Qty!!!');
            return;
        }
        context.setState({ load: true, message: 'Adding Spares!!!' });
        let data = (ReadCookie("branch"));
        let branch_id;
        for (var i = 0; i < data.length; i++) {
            branch_id = data[i].branch_id;
        }
        $.ajax({
            type: 'POST',
            data: { 'spares': JSON.stringify(spares), 'id': context.props.item.id, branch_id },
            url: Server() + 'Sales/JobCard/AddSpares.php',
            success: function(data) {
                console.log(data);
                if (data == 1) {
                    context.setState({ load: false, addingspares: [], addSpares: false })
                    context.props.refresh();
                }
                else {
                    alert('Error')
                    context.setState({ load: false })
                }
            },
            error: function(err) {
                context.setState({ load: false });
                alert('Try again!!!!')
            }
        });

    }


    render() {
        let { load, message, addingspares, addSpares, spares } = this.state;
        let i = 1;
        return (
            <div>
                <Loading load={load} message={message} />

                <Dialog fullWidth={true} maxWidth={'lg'} open={addSpares} 
                    onClose={ () => { this.setState({ addSpares: false }) }} 
                    aria-labelledby="max-width-dialog-title">
                    <DialogTitle id="responsive-dialog-title">
                        {"Add Spares"}
                    </DialogTitle>
                    <DialogContent>
                        <table width="100%" id="table">
                            <tr>
                                <th id='tableheader'><center>Sino</center></th>
                                <th id='tableheader'  style={{width: '30%'}}><center>Spares</center></th>
                                <th id='tableheader'><center>Brand</center></th>
                                <th id='tableheader' style={{width: '4%'}}><center>Qty</center></th>
                                <th id='tableheader' style={{width: '4%'}}><center>Discount</center></th>
                                <th id='tableheader' style={{width: '3%'}}><center>Tax</center></th>
                                <th id='tableheader'><center>Unit Price</center></th>
                                <th id='tableheader'><center>Tax Price</center></th>
                                <th id='tableheader'><center>Total Price</center></th>
                                <th id='tableheader'><center>Action</center></th>
                            </tr>
                            {
                                addingspares.map((c) => {
                                    return (
                                        <tr>
                                            <td>{i++}</td>
                                            <td>
                                            <datalist id="suggestionspartno">
                                                {spares.map((c) => {
                                                return (
                                                    <option id='box'>
                                                        {c.part_alias+'->'+c.spare_name+'->'+c.partno+'->'+c.brand_name}
                                                    </option>
                                                )
                                                })}
                                            </datalist>
                                            <input style={{height: 35, width: '100%'}} onChange={ (event) => this.partcode(event, c.id)} 
                                                autoComplete="on" list="suggestionspartno" 
                                                value={c.dropdown} id={c.id}/>
                                            </td>
                                            <td>{c.brand_name}</td>
                                            <td><Input type={"number"} placeholder="Qty" value={c.qty} onChange={this.onChangess('qty', c.id)} /></td>
                                            <td><Input type={"number"} placeholder="Dis%" value={c.discountper} onChange={this.onChangess('discountper', c.id)} /></td>
                                            <td>{c.tax}</td>
                                            <td>{this.makeDecimalPoint(c.mrp)}</td>
                                            <td>{this.makeDecimalPoint(c.taxprice)}</td>
                                            <td>{this.makeDecimalPoint(c.totprice)}</td>
                                            <td>
                                                <center style={{color: 'red', cursor: 'pointer'}} 
                                                    onClick={() => this.deleteItem(c.id)}>
                                                    Delete
                                                </center>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                        <br/>
                        <center><Button onClick={this.addItem}>Add Item</Button></center>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ addSpares: false }) }}>Close</Button>
                        <Button onClick={this.AddSpares}>Save Spare</Button>
                    </DialogActions>
                </Dialog>


                <center><Button onClick={this.getAllSpares}>Add Spares</Button></center>
            </div>
        );
    }

}